import React from 'react'
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export default function ShipmentBasicComponent({ orderStatus, customers, NetworkType, selectedOrder, onInnerBasicFormChange }: any) {
  return (
    <>
      <AccordionContainer
        child={
          <><div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
              label="NetworkType"
              labelField="Description"
              list={NetworkType}
              onValueChange={(event: any) => {
                onInnerBasicFormChange(
                  event.target.value,
                  'NetworkTypeId'
                );
              }}
              optionName='Choose NetworkType'
              type="select"
              value={selectedOrder?.NetworkTypeId}
              valueField="Value" />
            <InputContainer
              label="Tracking Number"
              name="Tracking Number"
              onValueChange={(event: any) => {
                onInnerBasicFormChange(
                  event.target.value,
                  'TrackingNumber'

                );
              }}
              type="text"
              value={selectedOrder?.TrackingNumber} />

            <InputContainer
              label="Invoice Number"
              name="InvoiceNumber"
              onValueChange={(event: any) => {
                onInnerBasicFormChange(
                  event.target.value,
                  'InvoiceNumber'

                );
              }}
              type="text"
              value={selectedOrder?.InvoiceNumber} />
            <InputContainer
              label="Customer name"
              labelField="UserName"
              list={customers}
              onValueChange={(event: any) => {
                onInnerBasicFormChange(
                  event.target.value,
                  'CustomerId'
                );
              }}
              optionName='Choose Customer'
              type="select"
              value={selectedOrder?.CustomerId}
              valueField="Id"
            />



            <InputContainer
              label="Order Status"
              labelField="Text"
              list={orderStatus}
              onValueChange={(event: any) => {
                onInnerBasicFormChange(
                  event.target.value,
                  'LogisticsOrderStatusId'
                );
              }}
              optionName='Choose ShippingStatus'
              type="select"
              value={selectedOrder?.LogisticsOrderStatusId}
              valueField="Value" />
            {/* <InputContainer
              label="Total distance"
              name="TotalDistance"
              onValueChange={(event: any) => {
                onInnerBasicFormChange(
                  event.target.value,
                  'quote?.TotalDistance'

                );
              }}
              type="number"
              value={selectedOrder?.quote?.TotalDistance} /> */}
            <InputContainer
              label="Price"
              name="Price"
              onValueChange={(event: any) => {
                onInnerBasicFormChange(
                  event.target.value,
                  '@ondc/org/linked_order.items[0].price.value'
                );
              }}
              type="number"
              value={
                selectedOrder?.["@ondc/org/linked_order"]?.items?.[0]?.price?.value || ""
              }
            />
          </div>

            <div className='col-span-full'>
              <InputContainer
                label="Description"
                onValueChange={(event: any) => {
                  onInnerBasicFormChange(
                    event.target.value,
                    'Description'
                  );
                }}
                type="text"
                value={selectedOrder?.Description} /></div></>
        }
        expandedPanel="basicInfo"
        headerTitle="Basic Info"
      />
    </>
  )
}